import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLoader = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.9005 20.1762C13.9667 22.9159 8.45242 22.5882 4.93256 19.0629C1.41271 15.5376 1.08555 10.0148 3.82103 6.07501L4.56994 6.82507C2.20497 10.3938 2.52818 15.1705 5.67359 18.3207C8.81899 21.471 13.6632 21.8697 17.1516 19.4261L17.9005 20.1762ZM6.793 4.59858L6.0441 3.84852C9.97782 1.10882 15.4172 1.36147 19.012 4.96176C22.6067 8.56206 22.9339 14.0849 20.1235 17.9497L19.3746 17.1996C21.7396 13.6309 21.4164 8.85419 18.271 5.70393C15.1256 2.55367 10.2813 2.15496 6.793 4.59858Z'
    />
  </svg>
);
export default SvgLoader;
